export default __webpack_public_path__ + "static/media/T840_CoC.da43ee46.pdf";